import React, { useState, useEffect } from 'react';
import FormSection from 'components/sales/formSection/formSection';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import localization from 'assets/localization/localization';

const FacilitiesInVicinity = ({ handleValue }) => {
  const vicinityFacilities = {
    corporateOffices: '',
    restaurantsInVicinity: '',
    otherDemandPoints: '',
  };

  const [vicinityFacilitiesData, setvicinityFacilitiesData] = useState(
    vicinityFacilities
  );

  const handleFormData = () => {
    if (
      vicinityFacilitiesData.corporateOffices !== '' &&
      vicinityFacilitiesData.restaurantsInVicinity !== ''
    ) {
      handleValue({
        corporate_offices_in_vicinity: vicinityFacilitiesData.corporateOffices,
        restaurants_in_vicinity: vicinityFacilitiesData.restaurantsInVicinity,
        other_demand_in_vicinity: vicinityFacilitiesData.otherDemandPoints,
      });
    } else {
      handleValue(null);
    }
  };

  useEffect(() => {
    handleFormData();
  }, [vicinityFacilitiesData]);

  return (
    <FormSection title={localization.facilitiesTitle}>
      <ConstantInput
        label={localization.corporateOffices}
        regex={Regex.alphaNumeric.test(vicinityFacilitiesData.corporateOffices)}
        errorMsg={
          vicinityFacilitiesData.corporateOffices
            ? localization.alphaErrorMg
            : localization.requiredCorporateOffices
        }
        type="text"
        handleChange={(val) => {
          setvicinityFacilitiesData({
            ...vicinityFacilitiesData,
            corporateOffices: val,
          });
        }}
        required
        isStarRequired={true}
      />
      <ConstantInput
        label={localization.restaurantsVicnity}
        regex={Regex.alphaNumeric.test(
          vicinityFacilitiesData.restaurantsInVicinity
        )}
        errorMsg={
          vicinityFacilitiesData.restaurantsInVicinity
            ? localization.alphaErrorMg
            : localization.requiredRestaurantsVicinity
        }
        type="text"
        handleChange={(val) => {
          setvicinityFacilitiesData({
            ...vicinityFacilitiesData,
            restaurantsInVicinity: val,
          });
        }}
        required
        isStarRequired={true}
      />
      <ConstantInput
        label={localization.otherVicinity}
        regex={Regex.charSpace.test(vicinityFacilitiesData.otherDemandPoints)}
        errorMsg={
          vicinityFacilitiesData.otherDemandPoints
            ? localization.alphaErrorMg
            : ''
        }
        type="text"
        handleChange={(val) => {
          setvicinityFacilitiesData({
            ...vicinityFacilitiesData,
            otherDemandPoints: val,
          });
        }}
      />
    </FormSection>
  );
};
export default FacilitiesInVicinity;
